import React from 'react';
import { Caption } from '~/shared/Typography';
import { Box, VStack, Link } from 'native-base';
import { faBagShopping, faCheck } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from '~/shared/Icon';
import { useI18n } from '@springbig/shared';

export const RedirectPage = () => {

    const { t } = useI18n();
    const uri = decodeURIComponent(location.pathname
        .split('/')[3])
        .replaceAll('%3A', ':')
        .replaceAll('%2F', '/');

    return (
        <Box w={'clamp(320px, 100vw, 480px)'} mx={'auto'} h={'100vh'} overflow={'hidden'} p={4}>
            <VStack justifyContent={'space-evenly'} alignItems={'center'} h={'100%'} space={8}>
                <VStack position={'relative'} space={4} alignItems={'center'}>
                    <Box position={'absolute'} top={7} right={4} bg={'#4cf912'} p={2} rounded={'full'}>
                        <SpIcon icon={faCheck} color={'white'} size={24} />
                    </Box>
                    <SpIcon icon={faBagShopping} color={'#128ff9'} size={128} />
                    <Caption fontSize={24} color={'#128ff9'}>
                        { t('shop.order_submitted') }
                    </Caption>
                </VStack>
                <Link href={uri} w={'100%'} bg={'#128ff9'} rounded={'xl'}>
                    <Caption
                        color={'white'}
                        px={6}
                        py={4}
                        w={'100%'}
                        textAlign={'center'}
                    >
                        { t('shop.return_to_app') }
                    </Caption>
                </Link>
            </VStack>
        </Box>
    );
};
